// eslint-disable-next-line no-restricted-imports
import { Tab, Tabs } from '@mui/material';
// eslint-disable-next-line no-restricted-imports
export type { TabProps as MuiTabProps, TabsProps as MuiTabsProps } from '@mui/material';

export const MuiTab = Tab;
export const MuiTabs = Tabs;
